import React from 'react';
import { ResponsivePie } from '@nivo/pie' 

export default function PieGraph({data}) {

  /*const data2 = [
    {
      "id": "Pendente de Aceite",
      "label": "Pendente de Aceite",
      "value": 520
    },
    {
      "id": "Pendente de Pagamento",
      "label": "Pendente de Pagamento",
      "value": 131
    },
    {
      "id": "Pagamento Realizado",
      "label": "Pagamento Realizado",
      "value": 131
    }
  ];*/

return(
    <ResponsivePie
        data={data}
        margin={{ top: 0, right:110, bottom: 100, left: 110 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={0}
        colors={{ scheme: 'pastel1' }}
        borderWidth={2}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
        enableRadialLabels={false}
        radialLabelsSkipAngle={5}
        radialLabelsTextXOffset={6}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={5}
        radialLabelsLinkHorizontalLength={4}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#333333"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        legends={[
            {
                anchor: 'bottom-left',
                direction: 'column',
                justify: false,
                translateX: 10,
                translateY: 60,
                itemsSpacing: 1,
                itemDirection: 'left-to-right',
                itemWidth: 100,
                itemHeight: 15,
                itemOpacity: 0.75,
                symbolSize: 9,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
)};